import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ServiceUsageCardCmp_ServiceUsage_Fragment = graphql(`
  fragment ServiceUsageCardCmp_ServiceUsage_Fragment on ServiceUsage {
    _id
    __typename
    specialService {
      ...ServiceUsageCardCmp_Service_Fragment
    }
    contentOriginId
    index
    quantity {
      value
      unitId
    }
    serviceId
    serviceOriginId
    serviceUsageOrigin {
      missionTypeId
      serviceUsageId
    }
    settings {
      showAmountsInQuotation
      showCostsInQuotation
      showMaterialsInQuotation
      showQuantitiesInQuotation
    }
  }
`);

export type ServiceUsageCardCmp_ServiceUsage = ResultOf<
  typeof ServiceUsageCardCmp_ServiceUsage_Fragment
>;
